import React, { useEffect, useState } from "react";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import DashboardLeftMenu from "../DashboardLeftMenu";
import DashboardHeader from "../../Header/DashboardHeader";
import "react-datepicker/dist/react-datepicker.css";
import { NODE_HOST_URL_v1 } from "../api/Api";
import Axios from "../../../axios/Axios";
import Spining from "../../UI/Spining/Spining";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";

const CtaDetailReport = () => {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    const { startDate, endDate, submitVia, campId, btnName } = useParams();
    const param = useParams();
    console.log(param);

    const [error, setError] = useState({
        errorStatus: false,
        errorMessage: "",
        bgColor: "",
    });
    const [urlDataReport, setUrlDataReport] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopyUrl = async (url, i) => {
        try {
            await navigator.clipboard.writeText(url || "");
            setCopiedIndex(i);
            setTimeout(() => setCopiedIndex(prev => (prev === i ? null : prev)), 1500);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    useEffect(() => {
        SummaryReport();
    }, [])

    const formatDate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const SummaryReport = async () => {
        let paramData = {
            fromdate: formatDate(startDate),
            todate: formatDate(endDate),
            user_id: userId,
            submit_via: submitVia === "pannel" ? 'PANNEL' : "API",
            token: userToken,
            method: submitVia === "pannel" ? "camp_quickreply_detail" : "api_quickreply_detail",
            camp_id: campId,
            btn_name: btnName
        }
        let { data } = await Axios.post(`${NODE_HOST_URL_v1}/click_reply`, paramData)
        if (data.success) {
            // console.log(data.data);
            setUrlDataReport(data.data);
        }
        else {
            setError({
                errorStatus: true,
                errorMessage: "alert alert-danger",
                bgColor: data.message,
            });
        }

    }


    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="card">
                        {isLoading && <Spining />}
                        <div className="card-body">
                            <div className="container-fluid p-0">
                                <div className="row">
                                    <div className="col-md-12">
                                        {error.errorStatus && (
                                            <div className={error.bgColor} role="alert">
                                                <button
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="alert"
                                                    aria-label="Close"
                                                >
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <div>{error.errorMessage}</div>
                                            </div>
                                        )}
                                        <h5 className="card-title">CTA Detail Report</h5>
                                    </div>
                                </div>

                                <div>
                                    {urlDataReport.length > 0 ? (
                                        <>
                                            <div className="row">
                                                <div className="col-6"></div>
                                                <div className="col-6">

                                                    {/* <button className="btn btn-warning float-right mb-2" onClick={""}>Download</button> */}

                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-striped table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th><span>Campaign ID</span></th>
                                                            <th><span>Mobile</span></th>
                                                            {/* <th><span>Brand Number</span></th> */}
                                                            {submitVia === "pannel" && <th><span>Button Name</span></th>}
                                                            <th><span>Total Count</span></th>
                                                            <th><span>Main URL</span></th>
                                                            <th><span>Short URL</span></th>
                                                            <th><span>IP</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {urlDataReport.map((item, i) => (
                                                            <tr key={i}>
                                                                <td>{item.camp_id}</td>
                                                                <td>{item.phone_number}</td>
                                                                {/* <td>{item.brand_number}</td> */}
                                                                {submitVia === "pannel" && <td>{item.btn_name}</td>}
                                                                <td>{item.url_clickcount}</td>
                                                                <td>
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "6px", maxWidth: "220px" }}>
                                                                        <span
                                                                            title={item.main_url}
                                                                            style={{
                                                                                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                                                                                display: "inline-block", maxWidth: "180px",
                                                                            }}
                                                                        >
                                                                            {item.main_url}
                                                                        </span>
                                                                        <button
                                                                            type="button"
                                                                            title="Copy URL"
                                                                            onClick={() => handleCopyUrl(item.main_url, i)}
                                                                            style={{ border: "none", background: "none", cursor: "pointer", color: copiedIndex === i ? "#16a34a" : "#64748b", padding: 0, flexShrink: 0 }}
                                                                        >
                                                                            <FontAwesomeIcon icon={copiedIndex === i ? faCheck : faCopy} style={{ fontSize: "12px" }} />
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                                <td>{item.short_url}</td>
                                                                <td>{item.ip}</td>
                                                            </tr>

                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>  </>
                                    ) :
                                        //   urlDataReport.length > 0 && submitVia === "api" ? (
                                        //     <div className="table-responsive">
                                        //       <table className="table table-striped table-sm">
                                        //         <thead>
                                        //           <tr>
                                        //             <th>Date</th>
                                        //             <th>Total Count</th>
                                        //           </tr>
                                        //         </thead>
                                        //         <tbody>
                                        //           {urlDataReport.map((item, i) => (
                                        //             <tr key={i}>
                                        //               <td>{item.date}</td>
                                        //               <td>{item.total_count}</td>
                                        //             </tr>
                                        //           ))}
                                        //         </tbody>
                                        //       </table>
                                        //     </div>) : 
                                        (
                                            <div className="text-center">
                                                <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                <p>Data Not Found</p>
                                            </div>
                                        )
                                    }



                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default CtaDetailReport;
